import { CSSProperties, PropsWithChildren, ReactNode } from "react";
import { MapContainer, TileLayer } from "react-leaflet";

export const LEAFLET_MAP_URL = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
export const LEAFLET_TILE_ATTRIBUITION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export const INITIAL_MAP_ZOOM = 13;
export const MAX_MAP_ZOOM = 30;
export const DEFAULT_EASE_LINEARITY = 0.35;

interface MapWrapperProps {
  mapCenter: [number, number];
  zoom?: number;
  styles: CSSProperties;
  children?: ReactNode;
}

const MapWrapper = (props: MapWrapperProps) => {
  const { mapCenter, zoom, styles, children } = props;

  return (
    <MapContainer
      center={mapCenter}
      zoom={zoom || INITIAL_MAP_ZOOM}
      easeLinearity={0.35}
      maxZoom={MAX_MAP_ZOOM}
      style={styles}
    >
      <TileLayer
        attribution={LEAFLET_TILE_ATTRIBUITION}
        url={LEAFLET_MAP_URL}
      />
      {children}
    </MapContainer>
  );
};

export default MapWrapper;
